import * as React from 'react';

export interface PreferenceCookieInterface {
  allowsCookies?: boolean;
}

export const CookieContext = React.createContext<PreferenceCookieInterface>({});
